import { isAnonymousReview } from '$lib/config/review';
import type { PageLoad } from './$types';

export const load: PageLoad = async () => {
	if (isAnonymousReview) {
		return {
			authorGroups: {}
		};
	}

	const { authorGroups } = await import('$lib/data/authors');

	return {
		authorGroups
	};
};
